<template>
  <div data-component-name="Installation.OotbiModelSelect">
    <AppDropdown.Base
      v-model="currentOption"
      :options="capacityOptions"
      :label="$t('installation.select-ootbi-model')"
      key-attribute="label"
    />
  </div>
</template>

<script setup lang="ts">
import AppDropdown from '~/components/redesign/AppDropdown';

// utils
import { isString, toSafeArray } from '~/utils';

// constants
import { PATHS } from '~/constants';

const props = withDefaults(
  defineProps<{
    options?: unknown[];
  }>(),
  {
    options: () => [],
  },
);

const router = useRouter();
const { path } = useRoute();
const localePathWithSlash = useLocalePathWithSlash();

const capacityOptions = computed(() =>
  props.options.map(({ slug }) => {
    return {
      to: isString(slug) ? PATHS.INSTALLATION.path + slug : '#',
      label: slugToLabel(slug),
    };
  }),
);

const currentOption = computed({
  get: () =>
    capacityOptions.value.find(
      option => path === localePathWithSlash(option.to),
    ) ?? capacityOptions.value[0],
  set: value => {
    if (value) router.push(localePathWithSlash(value?.to));
  },
});

const slugToLabel = (slug: string) => {
  const segments = toSafeArray(slug.split('-'));

  const firstSegment = segments[0]?.toUpperCase();
  const lastSegment = segments[segments.length - 1]?.toUpperCase();

  const middleSegments = segments.slice(1, -1).join('/');

  return [firstSegment, middleSegments, lastSegment].join(' ');
};
</script>
